<template>
  <div
    v-if="tabs"
    class="c-tabs l-container"
    role="tabs"
  >
    <div class="c-tabs__title">
      <h2 class="t-heading-3 u-margin-bottom-large u-text-align-center">
        {{ title }}
      </h2>
    </div>
    <a
      id="RingSizeFinder"
      class="c-tabs--jumpLink"
    />
    <div
      v-if="tabs && tabs[0] && tabs[0].data && tabs[0].data.tabIconImage"
      class="c-tabs__image-menu l-flex l-flex--no-wrap u-margin-bottom-medium"
    >
      <ul role="tablist">
        <li
          v-for="(tab, index) in tabs"
          :key="index"
          class="c-tabs__image-menu-item t-paragraph-large"
          :class="[activeTab == index ? 'c-tabs__image-menu-item--active' : '']"
          role="tab"
          :aria-selected="activeTab === index ? true : false"
          @click="activeTab = index, changeBackground()"
        >
          <div>
            <img
              :src="tab.data.tabIconImage.src"
              :alt="tab.data.tabIconImage.alt || tabName(tab)"
              class="c-tabs__tab-image"
            >
          </div>
          <div>
            {{ tabName(tab) }}
          </div>
        </li>
      </ul>
    </div>
    <div
      v-else
      class="c-tabs__menu l-flex l-flex--justify-start u-margin-bottom-medium"
    >
      <ul role="tablist">
        <template v-for="(tab, index) in tabs">
          <li
            v-if="(productDetailsOnly && index == 0) || !productDetailsOnly"
            :key="index"
            class="c-tabs__menu-item t-heading-6"
            :class="[activeTab == index ? 'c-tabs__menu-item--active' : '']"
            role="tab"
            :aria-selected="activeTab === index ? true : false"
            @click="activeTab = index, rotateBackdrop()"
          >
            {{ tabName(tab) }}
          </li>
        </template>
      </ul>
    </div>
    <div
      v-for="(tab, index) in tabs"
      :key="index"
      class="c-tabs__tab"
    >
      <div
        v-if="activeTab == index"
        :name="tab.name"
        role="tabpanel"
      >
        <div
          v-if="tab.featuredImage"
          class="l-grid l-grid--2-col l-grid--align-start"
        >
          <div
            class="l-grid__item"
          >
            <wysiwyg
              :html="tab.description"
            />
          </div>
          <div
            class="l-grid__item"
          >
            <div :class="imageContainerClass">
              <div
                class="c-tabs__image"
                :style="{ backgroundImage: `url(${tab.featuredImage.src})` }"
              />
            </div>
          </div>
        </div>
        <div v-else>
          <wysiwyg :html="tab.description" />
        </div>
        <div v-if="tab.contentType == 'contentContainer' && tab.data.content">
          <ContentContainer
            :sections="tab.data.content"
            :get-product-function="getProductFunction"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Wysiwyg from "../wysiwyg/Wysiwyg";
import ContentContainer from "../contentContainer/ContentContainer";

export default {
  name: 'Tabs',
  components: {
    Wysiwyg,
    ContentContainer,
  },
  props: {
    tabs: {
      type: Array,
      default: null
    },
    title: {
      type: String,
      default: ''
    },
    getProductFunction: {
      type: Function,
      required: true
    },
    productDetailsOnly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activeTab: 0,
      backdropLocation: 0,
    }
  },
  computed: {

    imageContainerClass() {
      let results = 'c-tabs__image-container'
      if (this.backdropLocation == 0) {
        results += ' c-tabs__image-container--rotate-0'
      } else if(this.backdropLocation == 1) {
        results += ' c-tabs__image-container--rotate-1'
      } else if(this.backdropLocation == 2) {
        results += ' c-tabs__image-container--rotate-2'
      }
      return results
    }
  },
  created() {
    let tempActiveTab = 0
    if (this.tabs && this.tabs[0]) {
      for(let tab in this.tabs){
        if(this.tabs[tab].description){
          tempActiveTab = tab;
          break
        }
      }
    }
    this.activeTab = tempActiveTab;
  },
  methods: {
    rotateBackdrop() {
      setTimeout(function(scope) {
        if (scope.backdropLocation > 1) {
          scope.backdropLocation = 0;
        } else {
          scope.backdropLocation++
        }
      }, 10, this);

    },
    changeBackground() {

    },
    tabName(tab) {
      if (tab.name){
        return tab.name
      } else if (tab.data.title){
        return tab.data.title
      } else if (tab.fields){
        return tab.fields.title
      }
      return ''
    },
  }
}
</script>

<style lang="scss" scoped>
.c-tabs {
  padding: rem(50px) 0;
  position:relative;

  &__title {
    max-width:rem(600px);
    margin: auto;
  }
  &__tab {
    padding-left:rem(10px);
    padding-right:rem(10px);
  }
  &__tab-image {
    @include respond(phone) {
      max-height:rem(70px);
    }
  }
  &__image-menu {
    position: relative;
    @include respond(tab-land) {
      overflow: hidden;
      padding-left:10px;
    }
  }
  &__image-menu-item {
    cursor: pointer;
    display: inline-block;
    padding-bottom: rem(10px);
    padding:rem(40px);
    border-radius: 50%;
    text-align: center;

    &:not(:last-child) {
      margin-right: rem(10px);
    }
    @include respond(phone) {
      font-size: 15px;
      padding: rem(30px);
    }
    &--active {
      @include themify($themes) {
        background-color: themed('background', 'x-light');
      }
    }
  }
  &__menu {
    position: relative;
    @include respond(tab-land) {
      overflow: hidden;
      padding-left:10px;
    }
    &:before {
      content: '';
      position: absolute;
      bottom: 0;
      height: 1px;
      width: 105vw;
      transform: translateX(-50%);

      @include themify($themes) {
        width: 100vw;
        background-color: themed('foreground', 'section-border');
      }

      @include respond('tab-port') {
        transform: translateX(0);
      }
    }
  }
  &__menu-item {
    cursor: pointer;
    display: inline-block;
    padding-bottom: rem(10px);
    &:not(:last-child) {
      margin-right: rem(36px);
    }
    &--active {
      @include themify($themes) {
        border-bottom: $border-width-thick solid themed('secondary');
      }
    }
  }
  &__image-container {
    position: relative;
    height: 40vw;
    width: 40vw;
    max-height: rem(530px);
    max-width: rem(530px);
    margin: auto;
    //&::before {
    //  content: "";
    //  position: absolute;
    //  width: 120%;
    //  height: 120%;
    //  z-index: 1;
    //  left: 50%;
    //  top: 50%;
    //  transform: translate(-50%, -50%);
    //  background: url("https://enso-public.s3.us-west-2.amazonaws.com/web-assets/product-details-backdrop-image.png") 0 0 no-repeat;
    //  background-size: contain;
    //  transition: all 1s;
    //
    //  @include respond(tab-land) {
    //    width: 115%;
    //    height: 115%;
    //  }
    //}
    //&--rotate-1 {
    //  &::before {
    //    transform: translate(-50%, -50%) rotate(30deg);
    //    transition: all 1s;
    //  }
    //}
    //&--rotate-2 {
    //  &::before {
    //    transform: translate(-50%, -50%) rotate(60deg);
    //    transition: all 1s;
    //  }
    //}
    //&--rotate-3 {
    //  &::before {
    //    transform: translate(-50%, -50%) rotate(90deg);
    //    transition: all 1s;
    //  }
    //}

    @include respond(phone) {
      height: 70vw;
      width: 70vw;
    }
  }
  &__image {
    border-radius: 50%;
    height: 40vw;
    width: 40vw;
    max-height: rem(530px);
    max-width: rem(530px);
    background-position: center;
    background-size: cover;
    margin: auto;
    position: relative;
    z-index: 2;

    @include respond(phone) {
      height: 70vw;
      width: 70vw;
    }
  }
  &--jumpLink {
    position: absolute;
    top: rem(-160px)
  }
}
</style>
